/* Urban Interiors storefront enhancements (cards + cart drawer) */
(function(){
  var WA='923054307483';
  var fmt=function(c){return 'Rs. '+Math.round(c/100).toLocaleString('en-US');};
  var pcache={};
  function product(handle){
    if(!pcache[handle]){pcache[handle]=fetch('/products/'+handle+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null});}
    return pcache[handle];
  }
  /* ---------- Product cards: New Arrival badge ---------- */
  function enhanceCards(){
    document.querySelectorAll('.card-wrapper:not([data-ui-done])').forEach(function(card){
      card.setAttribute('data-ui-done','1');
      var a=card.querySelector('a[href*="/products/"]'); if(!a) return;
      var m=a.getAttribute('href').match(/\/products\/([^/?#]+)/); if(!m) return;
      product(m[1]).then(function(p){
        if(!p) return;
        var onSale=p.compare_at_price&&p.compare_at_price>p.price;
        if(!onSale&&p.tags&&p.tags.indexOf('New Arrival')>-1){
          var bs=card.querySelectorAll('.card__badge'), b=bs[bs.length-1];
          if(b&&!b.querySelector('.badge')){var e=document.createElement('span');e.className='badge ui-badge-new';e.textContent='New Arrival';b.appendChild(e);}
        }
      });
    });
  }
  /* ---------- Cart drawer ---------- */
  var cartP=null, cartT=0;
  function cart(force){
    if(force||!cartP||Date.now()-cartT>1500){cartT=Date.now();cartP=fetch('/cart.js').then(function(r){return r.json()});}
    return cartP;
  }
  function waText(c){
    var t="Hi Urban Interiors! I'd like to order (Cash on Delivery):\n";
    c.items.forEach(function(i){t+='\n• '+i.product_title+(i.variant_title?' ('+i.variant_title+')':'')+' x '+i.quantity+' = '+fmt(i.final_line_price);});
    t+='\n\nTotal: '+fmt(c.total_price)+' (+ delivery charges)\n\nName:\nPhone:\nFull address:\nCity:';
    return 'https://wa.me/'+WA+'?text='+encodeURIComponent(t);
  }
  function addToCart(id,btn){
    btn.disabled=true;btn.textContent='ADDING…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})})
    .then(function(r){return r.json()}).then(function(s){
      var d=document.querySelector('cart-drawer');
      cart(true);
      if(d&&d.renderContents&&s.sections){d.renderContents(s);}else{window.location.href='/cart';}
    }).catch(function(){window.location.href='/cart';});
  }
  function recs(d,c){
    var box=d.querySelector('.ui-recs'); if(!box||box.dataset.loaded||!c.items.length) return;
    box.dataset.loaded='1';
    var inCart=c.items.map(function(i){return i.product_id});
    fetch('/recommendations/products.json?product_id='+c.items[0].product_id+'&limit=8')
      .then(function(r){return r.json()}).then(function(j){
        var ps=(j.products||[]).filter(function(p){return inCart.indexOf(p.id)<0&&p.available}).slice(0,6);
        if(!ps.length){box.remove();return;}
        var h='<h3 class="ui-recs__h">Complement Your Piece</h3><p class="ui-recs__sub">Pieces that pair beautifully</p><div class="ui-recs__row">';
        ps.forEach(function(p){
          var v=p.variants.filter(function(x){return x.available})[0]||p.variants[0];
          var img=(p.featured_image||'').replace(/(\.[a-z]+)(\?|$)/i,'_300x$1$2');
          h+='<div class="ui-rec"><a href="'+p.url+'"><img src="'+img+'" alt="" loading="lazy"></a><a class="ui-rec__t" href="'+p.url+'">'+p.title+'</a><span class="ui-rec__p">'+fmt(v.price)+'</span><button type="button" class="ui-rec__add" data-id="'+v.id+'">ADD +</button></div>';
        });
        box.innerHTML=h+'</div>';
        box.querySelectorAll('.ui-rec__add').forEach(function(b){b.addEventListener('click',function(){addToCart(b.dataset.id,b);});});
      }).catch(function(){});
  }
  function enhanceDrawer(){
    var d=document.querySelector('cart-drawer'); if(!d) return;
    var inner=d.querySelector('.drawer__inner'); if(!inner) return;
    var empty=d.classList.contains('is-empty')||inner.classList.contains('is-empty');
    if(empty) return;
    var need=!d.querySelector('.ui-recs')||!d.querySelector('.ui-cart-extras')||!d.querySelector('.ui-wa-order')||(d.querySelector('.drawer__heading')&&!d.querySelector('.drawer__heading').dataset.ui);
    if(!need) return;
    cart(true).then(function(c){
      if(!c||!c.items.length) return;
      var h=d.querySelector('.drawer__heading');
      if(h&&!h.dataset.ui){h.dataset.ui='1';h.textContent='Your Bag ('+c.item_count+' '+(c.item_count===1?'Item':'Items')+')';}
      var items=d.querySelector('cart-drawer-items');
      if(items&&!d.querySelector('.ui-recs')){items.insertAdjacentHTML('afterend','<div class="ui-recs"></div>');}
      recs(d,c);
      var totals=d.querySelector('.totals');
      if(totals&&!d.querySelector('.ui-cart-extras')){
        totals.insertAdjacentHTML('afterend',
          '<div class="ui-cart-extras">'+
            '<div class="ui-ship"><span>Delivery</span><strong>Calculated at checkout</strong></div>'+
            '<form class="ui-disc" onsubmit="return false"><input type="text" placeholder="Discount code" aria-label="Discount code"><button type="submit">Apply Discount</button></form>'+
            '<p class="ui-disc__note" hidden>Your code will be applied at checkout.</p>'+
            '<div class="ui-paywith"><span>Pay Cash on Delivery (COD) or Online</span></div>'+
          '</div>');
        var form=d.querySelector('.ui-disc');
        form.addEventListener('submit',function(){
          var code=form.querySelector('input').value.trim(); if(!code) return;
          fetch('/discount/'+encodeURIComponent(code)+'?redirect=/cart.js').finally(function(){
            var n=d.querySelector('.ui-disc__note'); if(n){n.hidden=false;n.textContent='Code "'+code+'" saved, it will be applied at checkout.';}
          });
        });
      }
      var co=d.querySelector('#CartDrawer-Checkout');
      if(co&&!co.dataset.ui){co.dataset.ui='1';co.textContent='Proceed to Secure Checkout';}
      var ctas=d.querySelector('.cart__ctas');
      if(ctas&&!d.querySelector('.ui-wa-order')){
        ctas.insertAdjacentHTML('afterend','<a class="ui-wa-order" target="_blank" rel="noopener" href="'+waText(c)+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.4.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .2-1.2c-.1-.1-.3-.2-.5-.3z"/></svg>Quick Order via WhatsApp ('+fmt(c.total_price)+')</a><p class="ui-secure">🔒 100% Secure Checkout | Pakistani customer support on WhatsApp</p>');
      } else if(d.querySelector('.ui-wa-order')){
        d.querySelector('.ui-wa-order').href=waText(c);
      }
    });
  }
  var t=null;
  function run(){clearTimeout(t);t=setTimeout(function(){enhanceCards();enhanceDrawer();},60);}
  document.addEventListener('DOMContentLoaded',run);
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){var n=muts[i].target; if(n.closest&&n.closest('.ui-recs')) continue; run(); break;}
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
